
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiHttpClient } from './api-http-client';
import { oms } from '../models/models.generated';

@Injectable({
    providedIn: 'root'
})
export class CouponsHttpClient {

    constructor(private http: ApiHttpClient) {
    }

    public searchCoupons(request: oms.GetCouponsQuery): Observable<oms.Page<oms.CouponModel>> {
        return this.http.post<oms.Page<oms.CouponModel>>('coupons/search',request, true);
    }

    public getDetails(id: oms.Guid): Observable<oms.CouponModel> {
        return this.http.get<oms.CouponModel>('coupons/' + id, true);
    }

    public generate(request: oms.GenerateCouponCommand): Observable<oms.CouponModel> {
        return this.http.post<oms.CouponModel>('coupons/', request, true);
    }
}